import React from "react";
import "./Common_Vendor_Card.css";
import Common_Send_Button from "../common-send-button/Common_Send_Button";
import Common_Call_Button from "../common-send-button/common-call-button/Common_Call_Button";
const Common_Vendor_Card = ({ vendor, onClick, onClick2 }) => {
  if (!vendor) return null;

  return (
    <div className="vendor-card">
      <div className="card-image">
        <img src={vendor.image} alt={vendor.name} />
      </div>

      <div className="card-content">
        <div className="vendor-name-holder">
          <div className="vendor-name">
            <span>{vendor.name}</span>

            {vendor.verified && (
              <img
                src="/assets/images/verified.png"
                alt="Verified"
                className="vendor-card-badge"
              />
            )}
          </div>
          <div className="rating">
            <p>⭐4.5/5</p>
          </div>
        </div>

        <div className="location">{vendor.location}</div>

        <div className="material">
          <strong>Material :- {vendor.material}</strong>
        </div>

        <div className="description">{vendor.description}</div>
        <div className="buttons">
          <Common_Send_Button onClick={onClick} />
          <Common_Call_Button onClick2={onClick2} />
        </div>
      </div>
    </div>
  );
};

export default Common_Vendor_Card;
